import { render } from "./FlutterwavePayment.vue?vue&type=template&id=718a9f91&scoped=true"
import script from "./FlutterwavePayment.vue?vue&type=script&lang=js"
export * from "./FlutterwavePayment.vue?vue&type=script&lang=js"

import "./FlutterwavePayment.vue?vue&type=style&index=0&id=718a9f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718a9f91"]])

export default __exports__